import { Container } from "@mui/material";
import React from "react";
import AppBar from "../../organisms/appBar/appBar";
import Footer from "../../organisms/footer/footer";
import "./externalExamTemplateStyle.css";

export const ExternalExamTemplate = ({ content }) => {
  // appBar ve footer default olarak burada yer alıyor. Gerekirse sidebar eklenecek.

  return (
    <div className="templateBox">
      <div>
        {/* <AppBar /> */}
        <Container id="container">{content}</Container>
      </div>

      <Footer />
    </div>
  );
};
